export const comboAutoCompleteFiltersMixin = {
  methods: {
    referenceFilter (item, queryText, itemText) {
      const textOne = item.reference.replace(/[\W_]+/g, '').toLowerCase()
      const searchText = queryText.replace(/[\W_]+/g, '').toLowerCase()

      return textOne.indexOf(searchText) > -1
    },
    lesserReferenceFilter (item, queryText, itemText) {
      return true
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/comboAutoCompleteFiltersMixin.js